import { render, staticRenderFns } from "./supplierFee.vue?vue&type=template&id=48a3342a"
import script from "./supplierFee.vue?vue&type=script&lang=js"
export * from "./supplierFee.vue?vue&type=script&lang=js"
import style0 from "./supplierFee.vue?vue&type=style&index=0&id=48a3342a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports